import { React, useRef } from 'react';
import { useLanguage } from '../../Context/LanguageContext';
import styled from 'styled-components';

import { ReactComponent as SearchingSvg } from '../../image/Searching.svg';

function MovementSearchInput(props) {
  const { value, setValue, disabled } = props;

  const { t } = useLanguage();
  const InputRef = useRef();

  function handleChange(e) {
		setValue({ movementName: e.target.value });
	}

	function handleFocus(e) {
    
	}

	function handleBlur(e) {

	}

  return (
    <TopLevelWrapper disabled={disabled}>
      <SearchIcon />
      <Input
        ref={InputRef}
        type='text'
        placeholder={t('note.placeholder.searchMovement')}
        value={value.movementName}
        disabled={disabled}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </TopLevelWrapper>
  )
}

export default MovementSearchInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: calc(100% - 18px);
  height: 30px;

  gap: 8px;
  margin-top: 16px;
  padding: 0 8px 0 8px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 8px;
  background-color: ${props => props.disabled ? props.theme.line : props.theme.background};

  transition: all 0.3s ease-in-out;
`;

const SearchIcon = styled(SearchingSvg)`
  width: 24px;
  height: 24px;

  & path {
    fill: ${props => props.theme.line};
  }
`;

const Input = styled.input`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  border: 0px;

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  outline: none;

  background-color: ${props => props.disabled ? props.theme.line : props.theme.background};

  ::placeholder {
    color: ${props => props.theme.background};
  }

  ::disabled {
    background-color: ${props => props.theme.background};
  }

  transition: all 0.3s ease-in-out;
`;